module.exports = __webpack_public_path__ + "img/nav-insights.c35b5374.svg";